export default "__VITE_ASSET__aa1babb0__"